import { Suspense, lazy, Fragment } from "react";
import HeaderAnnouncement from "CommonComponents/HeaderAnnouncement";
import Navbar from "CommonComponents/Navbar/Navbar";
import GuideMoney from "./MoneyMakingGuide/GuideMoney";
import Hero2 from "./Hero2/Hero2";

const Hero = lazy(() => import("./Hero/Hero"));
const AppView = lazy(() => import("./AppView/AppView"));
const SpecialOffers = lazy(() => import("./SpecialOffers/SpecialOffers"));
const BusinessProsperity = lazy(() =>
  import("./BusinessProsperity/BusinessProsperity")
);
const MediaDaapApp = lazy(() => import("./MediaDaapApp/MediaDaapApp"));
const TrustDaapapp = lazy(() => import("./TrustDaapapp/TrustDaapapp"));
const DaapappFamilly = lazy(() => import("./DaapappFamilly/DaapappFamilly"));
const SelectedBusinesses = lazy(() => import("./TopBusinesses/TopBusinesses"));
const ImagesStores = lazy(() => import("./ImagesStores/ImagesStores"));
const FooterA = lazy(() => import("./FooterA/FooterA"));
const FooterB = lazy(() => import("./FooterB/FooterB"));
// import Hero from "./Hero/Hero";
// import AppView from "./AppView/AppView";
// import SpecialOffers from "./SpecialOffers/SpecialOffers";
// import BusinessProsperity from "./BusinessProsperity/BusinessProsperity";
// import MediaDaapApp from "./MediaDaapApp/MediaDaapApp";
// import TrustDaapapp from "./TrustDaapapp/TrustDaapapp";
// import DaapappFamilly from "./DaapappFamilly/DaapappFamilly";
// import SelectedBusinesses from "./TopBusinesses/TopBusinesses";
// import ImagesStores from "./ImagesStores/ImagesStores";
// import FooterA from "./FooterA/FooterA";
// import FooterB from "./FooterB/FooterB";

const Home = () => {
  document.title = "داپ اَپ ";
  return (
    <Suspense fallback={<div />}>
      <header>
        {/* <HeaderAnnouncement /> */}
        <Navbar />
      </header>
      <main className=" mt-5 pt-5 ">
        <Suspense fallback={<div />}>
          <Hero />
          <Hero2 />
        </Suspense>
        <Suspense fallback={<div />}>
          <GuideMoney />
          <AppView />
        </Suspense>
        <Suspense fallback={<div />}>
          <SpecialOffers />
        </Suspense>

        <Suspense fallback={<div />}>
          <BusinessProsperity />
          <TrustDaapapp />
        </Suspense>

        <Suspense fallback={<div />}>
          <DaapappFamilly />
          <ImagesStores />
        </Suspense>

        {/* <MediaDaapApp /> */}
        <SelectedBusinesses />
      </main>
      <footer>
        <FooterA />
        <FooterB />
      </footer>
    </Suspense>
  );
};

export default Home;
